<ng-container *ngIf="systems.activeSystem">
    <router-outlet></router-outlet>
</ng-container>